import deburr from 'lodash/deburr';
import { slugify, findNearestCoordinates, getDistance, formatDistance, formatHour, hasDistance, QueryString, parseHtml } from '@grandvision/utils';
import { Location, useApiClient, Stores } from '@grandvision/api-client';
import * as React from 'react';
import { useFeatureToggles, withApiConfig, withIntl } from '@grandvision/state';
import classnames from 'classnames';
import { Alert, Button, Dropdown, SkeletonLoader, IconLink, MediaQuery, Util as Util$1, LoaderScreen, GoogleMaps, Breadcrumbs, List, Accordion, AccordionItem } from '@grandvision/common';
import { Form, Input, Util, FormControl } from '@grandvision/forms';
import { createSelector } from 'reselect';
import { debounce } from 'throttle-debounce';
import { Icon } from '@grandvision/icons';
import { ServicesNotAvailable } from '@grandvision/store-model';

var defaultSearchWhitelist = ['postalCode', 'streetName', 'town'];
var normalize = function (value) {
    return typeof value === 'string' || typeof value === 'number'
        ? deburr(value.toString()).toLowerCase()
        : '';
};
var searchStore = function (store, query, searchWhitelist) {
    if (searchWhitelist === void 0) { searchWhitelist = defaultSearchWhitelist; }
    var normalizedQuery = normalize(query);
    return searchWhitelist.some(function (key) { return normalize(store[key]).includes(normalizedQuery); });
};

var normalizeTownName = function (town) {
    if (town === void 0) { town = ''; }
    return town
        .replace(/[\(\)\/]/g, '')
        .replace(/\-/g, '_')
        .replace(/\s/g, '-')
        .toLowerCase();
};

var createBreadcrumbs = function (store, rootLabel, storesRoute) {
    if (!storesRoute) {
        console.error('createBreadcrumbs: Could not create breadcrumbs because storesRoute was not found');
        return [];
    }
    return [
        {
            name: 'Home',
            url: '/',
        },
        {
            name: rootLabel,
            url: storesRoute,
        },
        {
            name: store.town,
            url: storesRoute + "?search=" + store.town,
        },
        {
            name: "" + store.storeName,
            url: storesRoute + "/" + store.slug,
        },
    ];
};
var getBookAppointmentUrl = function (bookAppointmentUrl) { return function (_a) {
    var code = _a.code;
    return bookAppointmentUrl + "?storeId=" + code;
}; };
var getStoreDetailUrl = function (storesListUrl) { return function (store) {
    return storesListUrl + "/" + slugify(store.town) + "/" + store.code;
}; };
var areServicesAvailable = function (store, services) { var _a; return !((_a = store === null || store === void 0 ? void 0 : store.servicesNotAvailable) === null || _a === void 0 ? void 0 : _a.some(function (notAvailable) { return services.includes(notAvailable); })); };

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/**
 * Multi-country getCoordinates workaround. Use api-client's
 * Location.getCoordinates instead, unless location-service is configured with
 * a GOOGLE_MAPS_COUNTRY_RESTRICTION with multiple country codes.
 */
var getCoordinatesMultiCountry = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var places, place, details;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Location.getPlacePredictionsExtended(apiUrl, {
                    place: request.query,
                })];
            case 1:
                places = (_b.sent()).places;
                place = places === null || places === void 0 ? void 0 : places[0];
                if (!place) {
                    throw new Error('No matching place found');
                }
                return [4 /*yield*/, Location.getPlaceDetails(apiUrl, { id: place.id })];
            case 2:
                details = _b.sent();
                return [2 /*return*/, {
                        address: ((_a = place.address) === null || _a === void 0 ? void 0 : _a.join(', ')) || '',
                        coordinates: details.coordinates,
                    }];
        }
    });
}); };

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  defaultSearchWhitelist: defaultSearchWhitelist,
  searchStore: searchStore,
  normalizeTownName: normalizeTownName,
  createBreadcrumbs: createBreadcrumbs,
  getBookAppointmentUrl: getBookAppointmentUrl,
  getStoreDetailUrl: getStoreDetailUrl,
  areServicesAvailable: areServicesAvailable,
  getCoordinatesMultiCountry: getCoordinatesMultiCountry
});

var withGetCoordinates = function (Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var WithGetCoordinates = function (props) {
        var isMultiCountryLocationsEnabled = useFeatureToggles().isMultiCountryLocationsEnabled;
        var getCoordinates = isMultiCountryLocationsEnabled
            ? getCoordinatesMultiCountry
            : Location.getCoordinates;
        return React.createElement(Component, __assign({}, props, { getCoordinates: getCoordinates }));
    };
    WithGetCoordinates.displayName = "WithGetCoordinates(" + wrappedName + ")";
    return WithGetCoordinates;
};

var useGetCoordinates = function () {
    var isMultiCountryLocationsEnabled = useFeatureToggles().isMultiCountryLocationsEnabled;
    return isMultiCountryLocationsEnabled ? getCoordinatesMultiCountry : Location.getCoordinates;
};

var cityRegex = /^([a-zA-Z_\s\-]*)$/;
var PreferredStoreFinder = /** @class */ (function (_super) {
    __extends(PreferredStoreFinder, _super);
    function PreferredStoreFinder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            search: '',
            isNoResults: false,
            stores: {
                list: [],
            },
        };
        _this.countries = [];
        _this.getDropdownOptions = function (distanceUnit) {
            var _a = _this.state, location = _a.location, stores = _a.stores;
            return stores.list.map(function (item) {
                var town = item.town, streetName = item.streetName, streetNumber = item.streetNumber, value = item.code;
                var distance = getDistance(location || {}, item);
                var label = town + " - " + streetName;
                if (streetNumber) {
                    label += " " + streetNumber;
                }
                if (distance !== Infinity) {
                    label += " (\u00B1 " + formatDistance(distance, distanceUnit, {
                        precision: 0,
                    }) + ")";
                }
                return { label: label, value: value };
            });
        };
        _this.handleBlur = function () {
            if (!_this.state.isTouched) {
                _this.setState({ isTouched: true });
            }
        };
        _this.handleSearchChange = function (_a) {
            var search = _a.value;
            return _this.setState({ search: search, isNoResults: false });
        };
        _this.handleStoreSelect = function (_a) {
            var value = _a.value;
            var onStoreSelect = _this.props.onStoreSelect;
            var list = _this.state.stores.list;
            var store = list.find(function (item) { return item.code === Number(value); });
            if (!store) {
                return;
            }
            onStoreSelect(store);
        };
        _this.handleClickCTA = function () { return __awaiter(_this, void 0, void 0, function () {
            var search, result, l, location, list, selected;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        search = this.state.search;
                        if (!search) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getCoordinatesResult(this.checkForPostalCode(search))];
                    case 1:
                        result = _a.sent();
                        if (!result) {
                            return [2 /*return*/, this.setState({ isNoResults: true })];
                        }
                        l = result.coordinates;
                        location = { lat: l.lat, lon: l.lng };
                        list = findNearestCoordinates(location, this.props.stores, {
                            limit: 10,
                        });
                        selected = list[0];
                        this.setState({
                            isNoResults: false,
                            location: location,
                            stores: { selected: selected, list: list },
                        }, function () { return _this.handleStoreSelect({ value: selected.code }); });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getDistinctCountries = function () {
            var stores = _this.props.stores;
            var result = [];
            stores.forEach(function (_a) {
                var country = _a.country;
                return !result.includes(country) && result.push(country);
            });
            return result;
        };
        _this.getCoordinatesResult = function (input) { return __awaiter(_this, void 0, void 0, function () {
            var _a, apiConfig, getCoordinates, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, apiConfig = _a.apiConfig, getCoordinates = _a.getCoordinates;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getCoordinates(apiConfig.locationsUrl, {
                                query: input,
                            })];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3:
                        e_1 = _b.sent();
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.validateCity = function (v) { return (v.trim() ? cityRegex.test(v) : false); };
        _this.isPostalCodeOrCity = function (v) {
            return [Util.validations.getPostalCodeRegex(_this.props.intl.country), _this.validateCity].some(function (validator) {
                return validator instanceof Function ? validator(v) : validator === null || validator === void 0 ? void 0 : validator.test(v);
            });
        };
        return _this;
    }
    PreferredStoreFinder.prototype.componentDidMount = function () {
        this.countries = this.getDistinctCountries();
    };
    PreferredStoreFinder.getDerivedStateFromProps = function (_a, prevState) {
        var _b;
        var selected = _a.selected, stores = _a.stores;
        if (!prevState.search && selected && (selected === null || selected === void 0 ? void 0 : selected.code) !== ((_b = prevState.stores.selected) === null || _b === void 0 ? void 0 : _b.code)) {
            // Initialize state from props if user hasn't searched
            return __assign(__assign({}, prevState), { isNoResults: false, location: selected, stores: {
                    selected: selected,
                    list: findNearestCoordinates(selected, stores, { limit: 10 }),
                } });
        }
        return null;
    };
    PreferredStoreFinder.prototype.render = function () {
        var _a;
        var intl = this.props.intl;
        var _b = this.state, search = _b.search, stores = _b.stores, isNoResults = _b.isNoResults, isTouched = _b.isTouched;
        var list = stores.list;
        if (!this.props.stores.length) {
            return React.createElement(Alert, { type: "error", message: intl.getLabel('stores.preferredStore.errorMessage') });
        }
        var isValid = this.isPostalCodeOrCity(search) && isTouched;
        var isInvalid = !this.isPostalCodeOrCity(search) && isTouched;
        var inputClasses = classnames('form-control__input', 'preferred-store-finder__input', {
            _is_valid: isValid,
            _is_invalid: isInvalid,
        });
        return (React.createElement("article", { className: "preferred-store-finder" },
            React.createElement("main", { className: "preferred-store-finder__main" },
                isNoResults && (React.createElement(Alert, { type: "info", message: intl.getLabel('stores.preferredStore.noResults') })),
                React.createElement("div", { className: "preferred-store-finder__search" },
                    React.createElement("label", { className: "form-control__label" },
                        intl.getLabel('stores.preferredStore.search.label'),
                        React.createElement("span", { className: "form-control__asterisk" }, "*")),
                    React.createElement(Form, { name: "preferred-store-finder", onSubmit: this.handleClickCTA, className: "preferred-store-finder__search-form" },
                        React.createElement("div", { className: "preferred-store-finder__search-form-content" },
                            React.createElement("div", { className: "preferred-store-finder__input-wrapper" },
                                React.createElement(Input, { id: "search", "data-t": "search", className: inputClasses, onChange: this.handleSearchChange, onBlur: this.handleBlur }),
                                !this.isPostalCodeOrCity(search) && isTouched && (React.createElement("span", { className: "form-control__error" }, intl.getLabel('checkout.address.city.errorMessage')))),
                            React.createElement(Button, { className: "preferred-store-finder__button", color: "secondary", caption: intl.getLabel('stores.preferredStore.cta'), onClick: this.handleClickCTA, disabled: !search || !this.isPostalCodeOrCity(search) })))),
                list.length > 0 && (React.createElement("div", { className: "preferred-store-finder__result" },
                    React.createElement("label", { className: "form-control" },
                        React.createElement("span", { className: "form-control__label" }, intl.getLabel('stores.preferredStore.result.label')),
                        React.createElement(Dropdown, { required: true, name: "result", handleChange: this.handleStoreSelect, options: this.getDropdownOptions(intl.distanceUnit), value: ((_a = stores === null || stores === void 0 ? void 0 : stores.selected) === null || _a === void 0 ? void 0 : _a.code) || '' })))))));
    };
    PreferredStoreFinder.prototype.checkForPostalCode = function (search) {
        var postCodeRegex = Util.validations.getPostalCodeRegex(this.props.intl.country);
        return (postCodeRegex === null || postCodeRegex === void 0 ? void 0 : postCodeRegex.test(search)) ? "postcode " + search : search;
    };
    return PreferredStoreFinder;
}(React.Component));
var PreferredStoreFinderLoader = function () { return (React.createElement(SkeletonLoader, null,
    React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "80px" },
        React.createElement("rect", { width: "80%", height: "32px", rx: "4", fill: "currentColor" }),
        React.createElement("rect", { width: "50%", height: "32px", rx: "4", fill: "currentColor", y: "48" })))); };
var WithStores = function (_a) {
    var apiConfig = _a.apiConfig, rest = __rest(_a, ["apiConfig"]);
    var _b = __read(useApiClient(Stores.list, null, apiConfig.storesUrl), 3), isLoading = _b[0], stores = _b[1], error = _b[2];
    if (error) {
        throw error;
    }
    if (isLoading) {
        return React.createElement(PreferredStoreFinderLoader, null);
    }
    return React.createElement(PreferredStoreFinder, __assign({ stores: stores || [], apiConfig: apiConfig }, rest));
};
WithStores.displayName = 'WithStores(PreferredStoreFinder)';
var PreferredStoreFinder$1 = withGetCoordinates(withApiConfig(withIntl(WithStores)));

var StoreContactField = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, fieldType = _a.fieldType, value = _a.value;
    var isPhone = fieldType === 'phone';
    var href = (isPhone ? 'tel' : 'mailto') + ":" + value;
    var iconName = isPhone ? 'phone' : 'mail';
    return (React.createElement(IconLink, { className: className, href: href, iconName: iconName }, value));
};

var DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
var getOpeningHours = function (openClosePairs) {
    return openClosePairs
        .map(function (_a) {
        var open = _a.open, close = _a.close;
        return formatHour(open) + "-" + formatHour(close);
    })
        .join(' ');
};
var isCurrentDay = function (day) {
    return DAYS[new Date().getDay() - 1] === day.toLowerCase();
};
var StoreOpeningHours = function (_a) {
    var intl = _a.intl, store = _a.store, _b = _a.highlightCurrentDay, highlightCurrentDay = _b === void 0 ? true : _b;
    return (React.createElement("dl", { className: "store-opening-hours" },
        React.createElement("div", { className: "store-opening-hours__days" }, DAYS.map(function (day) { return (React.createElement("dt", { className: classnames('store-opening-hours__day', highlightCurrentDay && isCurrentDay(day) && 'store-opening-hours__day--highlighted'), key: store.code + "-" + day }, intl.getLabel("stores." + day))); })),
        React.createElement("div", { className: "store-opening-hours__times" }, DAYS.map(function (day) {
            var key = day + "OpenClose";
            var hours = store[key] || [];
            return (React.createElement("dd", { key: store.code + "-" + key, className: classnames('store-opening-hours__time', !hours.length && 'store-opening-hours__time--closed', highlightCurrentDay && isCurrentDay(day) && 'store-opening-hours__time--highlighted') }, hours.length ? getOpeningHours(hours) : intl.getLabel('stores.closed')));
        }))));
};
var StoreOpeningHours$1 = withIntl(StoreOpeningHours);

var defaultAddressFormatter = function (store) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            store.streetName,
            store.streetNumber && " " + store.streetNumber,
            store.additionalStreetInfo && " " + store.additionalStreetInfo),
        React.createElement("div", null,
            store.postalCode,
            " ",
            store.town)));
};

var Store = /** @class */ (function (_super) {
    __extends(Store, _super);
    function Store() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isExpanded: false,
        };
        _this.onStoreClick = function (event) {
            _this.props.onStoreSelect && _this.props.onStoreSelect(_this.props.store.code || 0);
            event.preventDefault();
        };
        _this.toggleExpand = function (event) {
            _this.setState({ isExpanded: !_this.state.isExpanded });
            event.preventDefault();
        };
        _this.onStoreAction = function () {
            _this.props.onStoreAction && _this.props.onStoreAction(_this.props.store);
        };
        _this.isButtonAvailable = function (store, flag) {
            var _a = _this.props.filterButtonService, filterButtonService = _a === void 0 ? [] : _a;
            return flag && areServicesAvailable(store, filterButtonService);
        };
        return _this;
    }
    Store.prototype.render = function () {
        var _a = this.props, phoneHidden = _a.phoneHidden, emailHidden = _a.emailHidden, targetPathAppointment = _a.targetPathAppointment, store = _a.store, highlight = _a.highlight, onStoreAction = _a.onStoreAction, buttonText = _a.buttonText, intl = _a.intl, bookAppointmentUrl = _a.bookAppointmentUrl, storeDetailsUrl = _a.storeDetailsUrl, currentBreakpoint = _a.currentBreakpoint, addressFormatter = _a.addressFormatter;
        var classNames = classnames('store-item', {
            'store-item--highlight': highlight,
            _is_expanded: this.state.isExpanded,
        });
        var isMobile = currentBreakpoint === MediaQuery.BreakpointName.PHONE ||
            currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT;
        var formattedDistance = hasDistance(store) && formatDistance(store.distance, intl.distanceUnit);
        return (React.createElement("article", { className: classNames },
            React.createElement("div", { className: "store-item__content" },
                React.createElement("h4", null, storeDetailsUrl ? (React.createElement("a", { "data-t": "store-link-" + store.code, className: "store-item__link", href: storeDetailsUrl }, store.storeName)) : (React.createElement("button", { "data-t": "store-link-" + store.code, role: "button", className: "store-item__link", onClick: isMobile ? this.toggleExpand : this.onStoreClick }, store.storeName))),
                React.createElement("div", { className: "store-item__address", "data-t": "store-item-address" }, addressFormatter ? addressFormatter(store) : defaultAddressFormatter(store)),
                React.createElement("div", { className: "store-item__contact" },
                    !phoneHidden && store.Phone1 && (React.createElement(StoreContactField, { className: "store-item__contact-field", fieldType: "phone", value: store.Phone1, "data-t": "store-item-phone" })),
                    !emailHidden && store.storeEmailAddress && (React.createElement(StoreContactField, { className: "store-item__contact-field", fieldType: "email", value: store.storeEmailAddress, "data-t": "store-item-email" }))),
                formattedDistance && (React.createElement("span", { className: "store-item__distance", "data-t": "store-item-distance" }, formattedDistance)),
                React.createElement("button", { className: "store-item__expand-toggle desktop-hidden", role: "button", onClick: this.toggleExpand }, this.state.isExpanded ? (React.createElement(React.Fragment, null,
                    React.createElement(Icon, { name: "minus" }),
                    " ",
                    intl.getLabel('stores.showLess'))) : (React.createElement(React.Fragment, null,
                    React.createElement(Icon, { name: "plus" }),
                    " ",
                    intl.getLabel('stores.showMore'))))),
            React.createElement("div", { className: "store-item__opening-hours" },
                React.createElement(StoreOpeningHours$1, { store: store }),
                storeDetailsUrl && (React.createElement(Button, { variant: "outline", className: "store-item__action store-item__action-secondary desktop-hidden", "data-t": "store-details-" + store.code, href: storeDetailsUrl, caption: intl.getLabel('stores.storeDetails.more') }))),
            React.createElement("div", { className: "store-item__actions" },
                this.isButtonAvailable(store, !!onStoreAction) && (React.createElement(Button, { className: "store-item__action store-item__action-primary", "data-t": "select-store-" + store.code, caption: buttonText, onClick: this.onStoreAction })),
                this.isButtonAvailable(store, !onStoreAction) && (React.createElement(Button, { className: "store-item__action store-item__action-primary", "data-t": "select-store-" + store.code, caption: buttonText, href: bookAppointmentUrl || targetPathAppointment + "?storeId=" + store.code })),
                storeDetailsUrl && (React.createElement(Button, { variant: "outline", className: "store-item__action store-item__action-secondary mobile-hidden", "data-t": "store-details-" + store.code, href: storeDetailsUrl, caption: intl.getLabel('stores.storeDetails.more') })))));
    };
    return Store;
}(React.PureComponent));
var Store$1 = withIntl(MediaQuery.WithBreakpoints(Store));

var StoreList = /** @class */ (function (_super) {
    __extends(StoreList, _super);
    function StoreList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stores = {};
        return _this;
    }
    StoreList.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, highlightStore = _a.highlightStore, scrollToRef = _a.scrollToRef;
        if (prevProps.highlightStore !== highlightStore && typeof highlightStore === 'number') {
            var highlightedStore = this.stores[highlightStore];
            if (highlightedStore && scrollToRef.current) {
                Util$1.scrollToItem(scrollToRef.current, highlightedStore.offsetTop, 500);
            }
        }
    };
    StoreList.prototype.render = function () {
        var _this = this;
        var _a = this.props, items = _a.items, highlightStore = _a.highlightStore, storeAction = _a.storeAction, onStoreSelect = _a.onStoreSelect, buttonText = _a.buttonText, emailHidden = _a.emailHidden, phoneHidden = _a.phoneHidden, targetPathAppointment = _a.targetPathAppointment, getBookAppointmentUrl = _a.getBookAppointmentUrl, getStoreDetailUrl = _a.getStoreDetailUrl, addressFormatter = _a.addressFormatter, storeFilter = _a.storeFilter, filterButtonService = _a.filterButtonService;
        var itemsList = storeFilter ? items.filter(storeFilter) : __spread(items);
        return (React.createElement("ul", { className: "store-list" }, itemsList.map(function (item) { return (React.createElement("li", { key: item.code, className: "store-list__item", ref: function (el) {
                _this.stores[item.code] = el;
            } },
            React.createElement(Store$1, { store: item, onStoreSelect: onStoreSelect, onStoreAction: storeAction, highlight: highlightStore === item.code, buttonText: buttonText, phoneHidden: phoneHidden, emailHidden: emailHidden, targetPathAppointment: targetPathAppointment, bookAppointmentUrl: getBookAppointmentUrl && getBookAppointmentUrl(item), storeDetailsUrl: getStoreDetailUrl && getStoreDetailUrl(item), addressFormatter: addressFormatter, filterButtonService: filterButtonService }))); })));
    };
    StoreList.defaultProps = {
        items: [],
        phoneHidden: false,
        emailHidden: false,
    };
    return StoreList;
}(React.Component));

var SearchType;
(function (SearchType) {
    SearchType["Query"] = "query";
    SearchType["Location"] = "location";
})(SearchType || (SearchType = {}));

var StoreSearchForm = function (_a) {
    var onQueryChange = _a.onQueryChange, onSubmit = _a.onSubmit, _b = _a.initialValue, initialValue = _b === void 0 ? '' : _b, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, _d = _a.searchType, searchType = _d === void 0 ? SearchType.Query : _d;
    var handleFormSubmit = function (event) {
        event.preventDefault();
        if (searchType === SearchType.Location) {
            var query = event.target['store-search-query'].value;
            onSubmit && onSubmit(query);
        }
    };
    var handleChange = function (event) {
        if (searchType === SearchType.Query) {
            onQueryChange && onQueryChange(event.value);
        }
    };
    return (React.createElement("form", { className: "store-search-form", noValidate: true, onSubmit: handleFormSubmit },
        React.createElement(FormControl, { id: "store-search-query", type: "search", required: false, onChange: handleChange, initialState: { value: initialValue }, placeholder: placeholder }),
        React.createElement("button", { className: "store-search-form__submit", type: "submit" },
            React.createElement(Icon, { name: "search" }))));
};

var WithUserCoords = function (_a) {
    var children = _a.children, onUserCoords = _a.onUserCoords, onError = _a.onError, labels = _a.labels;
    var hasBrowserSupport = typeof window !== 'undefined' &&
        typeof window.navigator !== 'undefined' &&
        typeof window.navigator.geolocation !== 'undefined';
    var getUserCoords = hasBrowserSupport
        ? function () { return getCoords(onUserCoords, onError, labels); }
        : function () { return undefined; };
    return children && children({ hasBrowserSupport: hasBrowserSupport, getUserCoords: getUserCoords });
};
function getCoords(callback, handleError, labels) {
    navigator.geolocation.getCurrentPosition(function (position) {
        callback(position.coords);
    }, function (error) {
        console.warn('Failed to get user coords:', error);
        switch (error.code) {
            case error.PERMISSION_DENIED:
                handleError(labels.yourLocationPermission);
                break;
            default:
                handleError(labels.yourLocationError);
        }
    });
}

var MAX_FILTERED_STORES = 15;
var DEFAULT_DEBOUNCE_MS = 250;
var getFilteredStores = createSelector(function (state, props) { return props.stores; }, function (state, props) { return props.searchWhitelist; }, function (state, props) { return props.searchType; }, function (state) { return state.search; }, function (state) { return state.userCoords; }, function (state) { return state.queryCoords; }, function (stores, searchWhitelist, searchType, search, userCoords, queryCoords) {
    // query based search:
    // returns stores that match the query in one of the whitelisted attributes
    if (searchType === SearchType.Query && search.length > 2) {
        stores = stores.filter(function (store) { return searchStore(store, search, searchWhitelist); });
    }
    // location based search:
    // if coords of location are known, sort stores by distance to the location
    if (searchType === SearchType.Location && search !== '') {
        if (queryCoords) {
            stores = findNearestCoordinates({
                lat: queryCoords.coordinates.lat,
                lon: queryCoords.coordinates.lng,
            }, stores, { limit: MAX_FILTERED_STORES });
        }
        else if (!queryCoords) {
            stores = [];
        }
    }
    // if user coords are known, sort the stores by distance to the user
    if (userCoords) {
        stores = findNearestCoordinates({ lat: userCoords.latitude, lon: userCoords.longitude }, stores, { limit: MAX_FILTERED_STORES });
    }
    return stores;
});
var getMarkers = createSelector(getFilteredStores, function (state) { return state.userCoords; }, function (state) { return state.queryCoords; }, function (stores, userCoords, queryCoords) {
    var markers = stores.map(function (store) { return ({
        position: { lat: store.lat || 0, lng: store.lon || 0 },
        code: store.code,
        isUserLocation: false,
    }); });
    // If we have the coords of the user, add a marker to show their location
    if (userCoords) {
        markers.push({
            position: { lat: userCoords.latitude, lng: userCoords.longitude },
            isUserLocation: true,
        });
    }
    // If we have the coordinates of a search query, add a marker to show the location
    else if (queryCoords) {
        markers.push({
            position: queryCoords.coordinates,
            isUserLocation: true,
        });
    }
    return markers;
});
var getQueryParams = function () {
    if (typeof window === 'undefined' || !window.location) {
        return {};
    }
    var loc = window.location;
    return QueryString.parse(loc.search.substr(1, loc.search.length));
};
var StoreFinder = /** @class */ (function (_super) {
    __extends(StoreFinder, _super);
    function StoreFinder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mainRef = React.createRef();
        _this.state = {
            highlightStore: null,
            search: _this.props.initialValue || '',
            isLoading: true,
        };
        _this.clear = function () {
            _this.setState({ search: '' });
            var params = getQueryParams();
            params.search && delete params.search;
            var url = Object.keys(params).length > 0
                ? "" + window.location.pathname + QueryString.stringify(params)
                : window.location.pathname;
            window.history.replaceState(null, 'store-finder', url);
        };
        _this.setErrorState = function (search) {
            _this.setState({
                search: search,
                queryCoords: undefined,
                userCoords: undefined,
                highlightStore: null,
                isLoading: false,
            }, _this.updateHistoryState);
        };
        _this.updateSearchQuery = debounce(_this.props.debounceMs, function (search) {
            _this.setState({ search: search, highlightStore: null, isLoading: false }, _this.updateHistoryState);
        });
        _this.submitSearchQuery = function (search) { return __awaiter(_this, void 0, void 0, function () {
            var locationsUrl, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        locationsUrl = this.props.apiConfig.locationsUrl;
                        if (!locationsUrl) {
                            console.error('submitSearchQuery: No apiUrl found for coordinates request');
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.getCoordinates(locationsUrl, {
                                query: search,
                            })];
                    case 2:
                        result = _a.sent();
                        if (result) {
                            this.setState({
                                search: search,
                                queryCoords: result,
                                userCoords: undefined,
                                highlightStore: null,
                                isLoading: false,
                            }, this.updateHistoryState);
                        }
                        else {
                            console.error("Failed to fetch coordinates for stores. Result: " + result);
                            this.setErrorState(search);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.error("Failed to fetch coordinates for stores. Error: " + err_1);
                        this.setErrorState(search);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.onUpdateSelectedStore = function (highlightStore) {
            if (_this.props.updateSelectedStore) {
                _this.props.updateSelectedStore(highlightStore);
            }
            else {
                _this.setState({ highlightStore: highlightStore });
            }
        };
        _this.clearQueryCoords = function () {
            _this.setState({ queryCoords: undefined });
        };
        _this.updateHistoryState = function () {
            var params = __assign(__assign({}, getQueryParams()), (_this.state.search !== '' ? { search: _this.state.search } : {}));
            var url = Object.keys(params).length > 0
                ? "" + window.location.pathname + QueryString.stringify(params)
                : window.location.pathname;
            // clear queryCoords on empty searchquery to reset storelist
            if (_this.state.queryCoords && !_this.state.search) {
                _this.clearQueryCoords();
                window.history.replaceState(null, 'store-finder', window.location.pathname);
            }
            else {
                window.history.replaceState(null, 'store-finder', url);
            }
        };
        _this.handleUserCoords = function (userCoords) {
            _this.clear();
            _this.setState({ userCoords: userCoords, queryCoords: undefined, isLoading: false });
        };
        _this.handleLocationError = function (errorMessage) {
            _this.setState({ errorMessage: errorMessage, isLoading: false });
        };
        return _this;
    }
    StoreFinder.prototype.componentDidMount = function () {
        var _this = this;
        // When location based search is enabled, submit queryParams on init
        if (this.props.searchType === SearchType.Location && this.state.search !== '') {
            this.submitSearchQuery(this.state.search);
        }
        if (getQueryParams().userLocation === 'true') {
            getCoords(function (coords) { return _this.handleUserCoords(coords); }, function (errorMessage) { return _this.handleLocationError(errorMessage); }, {
                yourLocationPermission: this.props.intl.getLabel('stores.yourLocation.permissionDenied'),
                yourLocationError: this.props.intl.getLabel('stores.yourLocation.error'),
            });
        }
    };
    StoreFinder.prototype.render = function () {
        var _a = this.state, highlightStore = _a.highlightStore, userCoords = _a.userCoords, search = _a.search, isLoading = _a.isLoading;
        var _b = this.props, intl = _b.intl, storeAction = _b.storeAction, initialValue = _b.initialValue, phoneHidden = _b.phoneHidden, emailHidden = _b.emailHidden, showSearchBar = _b.showSearchBar, showCityName = _b.showCityName, showUseMyLocation = _b.showUseMyLocation, buttonText = _b.buttonText, getBookAppointmentUrl = _b.getBookAppointmentUrl, getStoreDetailUrl = _b.getStoreDetailUrl, currentBreakpoint = _b.currentBreakpoint, searchType = _b.searchType, addressFormatter = _b.addressFormatter, _c = _b.mapOptions, mapOptions = _c === void 0 ? {} : _c, storeFilter = _b.storeFilter, filterButtonService = _b.filterButtonService;
        var labels = {
            title: showCityName
                ? intl.getLabel('stores.form.findStore.titleWithCity') + (" " + initialValue)
                : intl.getLabel('stores.form.findStore.title'),
            selectStore: intl.getLabel('stores.actions.selectStore'),
            placeholder: intl.getLabel('stores.form.findStore.fields.location.placeholder'),
            noResult: intl.getLabel('stores.form.findStore.errors.noResult'),
            useMyLocation: intl.getLabel('stores.actions.useMyLocation'),
            yourLocation: intl.getLabel('stores.yourLocation'),
            yourLocationHint: intl.getLabel('stores.yourLocation.hint'),
            yourLocationPermission: intl.getLabel('stores.yourLocation.permissionDenied'),
            yourLocationError: intl.getLabel('stores.yourLocation.error'),
        };
        var stores = getFilteredStores(this.state, this.props);
        var markers = getMarkers(this.state, this.props);
        return (React.createElement("article", { className: "store-finder" },
            React.createElement("div", { className: "store-finder__main", ref: this.mainRef },
                showUseMyLocation && !isLoading && stores.length === 0 && !userCoords && (React.createElement(Alert, { className: "store-finder__location-alert", message: labels.yourLocationHint, icon: "info" })),
                React.createElement("header", { className: "store-finder__header" },
                    React.createElement("h1", { className: "h3 store-finder__title" }, labels.title),
                    showSearchBar && (React.createElement(StoreSearchForm, { onQueryChange: this.updateSearchQuery, onSubmit: this.submitSearchQuery, initialValue: search, placeholder: userCoords ? labels.yourLocation : labels.placeholder, searchType: searchType })),
                    showUseMyLocation && !userCoords && (React.createElement(React.Fragment, null,
                        React.createElement(WithUserCoords, { labels: labels, onUserCoords: this.handleUserCoords, onError: this.handleLocationError }, function (_a) {
                            var hasBrowserSupport = _a.hasBrowserSupport, getUserCoords = _a.getUserCoords;
                            return hasBrowserSupport ? (React.createElement(Button, { size: "custom", variant: "ghost", icon: "gps", className: "store-finder__use-my-location", onClick: getUserCoords, caption: labels.useMyLocation })) : null;
                        }),
                        this.state.errorMessage && (React.createElement(Alert, { type: "warning", icon: "warning", message: this.state.errorMessage, className: "store-finder__location-alert" }))))),
                isLoading && stores.length === 0 && React.createElement(LoaderScreen, { height: 50 }),
                stores.length > 0 && (React.createElement(StoreList, { items: stores, highlightStore: highlightStore, onStoreSelect: this.onUpdateSelectedStore, storeAction: storeAction, buttonText: buttonText || labels.selectStore, phoneHidden: phoneHidden, emailHidden: emailHidden, scrollToRef: this.mainRef, getBookAppointmentUrl: getBookAppointmentUrl, getStoreDetailUrl: getStoreDetailUrl, addressFormatter: addressFormatter, storeFilter: storeFilter, filterButtonService: filterButtonService })),
                !isLoading && stores.length === 0 && search.length !== 0 && (React.createElement("div", { className: "store-finder__message" },
                    React.createElement("span", { className: "h4" }, "" + labels.noResult,
                        " ",
                        search ? "'" + search + "'" : '')))),
            React.createElement("aside", { className: "store-finder__map" }, currentBreakpoint !== MediaQuery.BreakpointName.PHONE && (React.createElement(GoogleMaps, { markers: markers, highlight: highlightStore, onMarkerClick: this.onUpdateSelectedStore, mapOptions: mapOptions })))));
    };
    StoreFinder.defaultProps = {
        phoneHidden: false,
        emailHidden: false,
        showSearchBar: true,
        showCityName: false,
        searchWhitelist: defaultSearchWhitelist,
        debounceMs: DEFAULT_DEBOUNCE_MS,
        searchType: SearchType.Query,
    };
    return StoreFinder;
}(React.PureComponent));
var StoreFinder$1 = withGetCoordinates(withApiConfig(withIntl(MediaQuery.WithBreakpoints(StoreFinder))));

var StoreAwards = function (_a) {
    var awards = _a.awards, className = _a.className, title = _a.title;
    if (!awards || !awards.length || !awards[0].image) {
        return null;
    }
    return (React.createElement("div", { className: classnames('store-awards', className) },
        title && React.createElement("h2", { className: "store-detail__heading" }, title),
        React.createElement("div", { className: "store-detail__award-images" }, awards.map(function (_a, key) {
            var name = _a.name, image = _a.image;
            return (React.createElement("img", { className: "store-detail__award", key: "award-" + key, src: image, alt: name }));
        }))));
};

var StoreDetail = function (_a) {
    var store = _a.store, intl = _a.intl, awards = _a.awards, breadcrumbs = _a.breadcrumbs, findStoreUrl = _a.findStoreUrl, sendMessageUrl = _a.sendMessageUrl, getBookAppointmentUrl = _a.getBookAppointmentUrl, _b = _a.openingHours, _c = _b === void 0 ? {} : _b, _d = _c.highlightCurrentDay, highlightCurrentDay = _d === void 0 ? true : _d, addressFormatter = _a.addressFormatter, className = _a.className, _e = _a.hideEmail, hideEmail = _e === void 0 ? false : _e, _f = _a.hidePhone, hidePhone = _f === void 0 ? false : _f;
    var storeOwnerName = store.ownerFirstName + " " + store.ownerLastName;
    var validStore = store && (store.storeName || store.streetName);
    var position = React.useMemo(function () { return ({ lat: (store && store.lat) || 0, lng: (store && store.lon) || 0 }); }, [store]);
    var markers = React.useMemo(function () { return (validStore ? [{ position: position, code: 0 }] : []); }, [
        store,
    ]);
    if (!validStore) {
        return (React.createElement("div", { className: "store-detail__error" },
            React.createElement("h1", null, intl.getLabel('stores.storeDetailsError.title')),
            React.createElement("p", null, intl.getLabel('stores.storeDetailsError.message')),
            React.createElement(Button, { caption: intl.getLabel('stores.form.findStore.title'), href: findStoreUrl || '/' })));
    }
    return (React.createElement("article", { className: classnames('store-detail', className) },
        React.createElement("div", { className: "store-detail__main" },
            store && store.storeDetailImage && (React.createElement("div", { className: "store-detail__image", role: "presentation", style: { backgroundImage: "url(" + store.storeDetailImage + ")" } })),
            React.createElement("div", { className: "store-detail__content" },
                breadcrumbs && (React.createElement("div", { className: "store-detail__breadcrumbs" },
                    React.createElement(Breadcrumbs, { pages: breadcrumbs }))),
                React.createElement("h1", { className: "store-detail__title" }, store.storeName),
                React.createElement("div", { className: "store-detail__address", "data-t": "store-detail-address" }, addressFormatter ? addressFormatter(store) : defaultAddressFormatter(store)),
                React.createElement("div", { className: "store-detail__contact" },
                    !hidePhone && store.Phone1 && (React.createElement(StoreContactField, { className: "store-detail__contact-field", fieldType: "phone", value: store.Phone1 })),
                    !hideEmail && store.storeEmailAddress && (React.createElement(StoreContactField, { className: "store-detail__contact-field", fieldType: "email", value: store.storeEmailAddress }))),
                React.createElement("div", { className: "store-detail__buttons" },
                    areServicesAvailable(store, [ServicesNotAvailable.APPOINTMENTS]) &&
                        getBookAppointmentUrl && (React.createElement(Button, { className: "store-detail__button", "data-t": "store-link-" + store.code, caption: intl.getLabel('stores.actions.selectStore'), href: getBookAppointmentUrl(store) })),
                    React.createElement(Button, { variant: "outline", className: "store-detail__button", caption: intl.getLabel('stores.actions.getDirections'), href: "https://www.google.com/maps/search/?api=1&query=" + store.lat + "," + store.lon, hrefTarget: "_blank" })),
                React.createElement("div", { className: "store-detail__columns" },
                    React.createElement("div", { className: "store-detail__opening-hours store-detail__block" },
                        React.createElement("h2", { className: "store-detail__heading" }, intl.getLabel('stores.openingTimes.title')),
                        React.createElement(StoreOpeningHours$1, { store: store, highlightCurrentDay: highlightCurrentDay }),
                        store.storenote && (React.createElement("div", { className: "store-detail__remarks" },
                            React.createElement("h2", { className: "store-detail__heading" },
                                intl.getLabel('stores.storeNote.title'),
                                ":"),
                            store.storenote))),
                    store.storeFacilities && (React.createElement("div", { className: "store-detail__services store-detail__block" },
                        React.createElement("h2", { className: "store-detail__heading" }, intl.getLabel('stores.services.title')),
                        React.createElement(List, { items: store.storeFacilities, type: "checkmark" })))),
                (store.ownerLastName || (awards && awards.length > 0)) && (React.createElement("div", { className: "store-detail__columns" },
                    store.ownerFirstName && store.ownerLastName && store.storeOwnerImage && (React.createElement("div", { className: "store-detail__store-manager store-detail__block" },
                        React.createElement("div", { className: "store-detail__manager" },
                            React.createElement("h2", { className: "store-detail__heading" }, intl.getLabel('stores.manager.title')),
                            store.storeOwnerImage && (React.createElement("img", { className: "store-detail__image", src: store.storeOwnerImage, alt: storeOwnerName })),
                            React.createElement("div", null, storeOwnerName)))),
                    awards && awards.length > 0 && (React.createElement(StoreAwards, { className: "store-detail__block", awards: awards, title: intl.getLabel('stores.awards.title') })))),
                store.storeDescription && (React.createElement("div", { className: "store-detail__description" },
                    React.createElement(Accordion, null,
                        React.createElement(AccordionItem, { id: "store-detail-description", label: intl.getLabel('stores.storeDetails.title') }, parseHtml(store.storeDescription))))),
                sendMessageUrl && (React.createElement("div", { className: "store-detail__customer-service" },
                    React.createElement("h2", { className: "store-detail__heading" }, intl.getLabel('stores.customerService.title')),
                    React.createElement(IconLink, { className: "", href: sendMessageUrl || '/', iconName: "mail" }, intl.getLabel('stores.customerService.message')))))),
        React.createElement("div", { className: "store-detail__map" },
            React.createElement(GoogleMaps, { markers: markers, center: position, highlight: 0 }))));
};
var StoreDetail$1 = withIntl(StoreDetail);

export { PreferredStoreFinder$1 as PreferredStoreFinder, SearchType, Store$1 as Store, StoreDetail$1 as StoreDetail, StoreFinder$1 as StoreFinder, StoreList, StoreOpeningHours$1 as StoreOpeningHours, StoreSearchForm, index as Util, useGetCoordinates, withGetCoordinates };
//# sourceMappingURL=index.es.js.map
